<template>
  <div class="verify-result">
    <div v-if="result">
      <img :src="result.icon" class="icon">
      <div class="text">
        <div class="title">{{ result.title }}</div>
        <div class="subtitle">{{ result.subtitle }}</div>
      </div>
      <div class="btn-action">
        <md-button type="primary" round class="btn-go-account" @click="switchRoute('UserOverview')">
          {{ result.goToAccount }}
        </md-button>
        <md-button
          v-if="result.goBindBank"
          type="primary"
          plain
          round
          class="btn-go-bank"
          @click="switchRoute('UserSecurity')"
        >
          {{ result.goBindBank }}
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        pendingTitle: 'We are verifying your application.',
        pendingSubtitle: 'We will inform you the result within 24 hours.',
        completedTitle: 'Congratulations!',
        completedSubtitle: 'You have completed onboarding process',
        goToAccount: 'Go to My Account',
        goBindBank: 'Bind bank account',
      },
      id: {
        pendingTitle: 'Kami sedang memverifikasi pengajuan Anda',
        pendingSubtitle: 'Kami akan memberikan hasil dalam 24 jam',
        completedTitle: 'Selamat!',
        completedSubtitle: 'Anda telah menyelesaikan proses verifikasi',
        goToAccount: 'Ke Akun Saya',
        goBindBank: 'Isi Akun Bank',
      },
    },
  },
  components: {
    [Button.name]: Button,
  },
  computed: {
    status() {
      return this.$store.state.userInfo.status
    },
    result() {
      return (
        {
          ENABLED: {
            icon: require('@/assets/image/verify/verify-completed.png'), // eslint-disable-line global-require
            title: this.$t('completedTitle'),
            subtitle: this.$t('completedSubtitle'),
            goToAccount: this.$t('goToAccount'),
            goBindBank: this.$t('goBindBank'),
          },
          PENDING: {
            icon: require('@/assets/image/icons/icon-pending.png'), // eslint-disable-line global-require
            title: this.$t('pendingTitle'),
            subtitle: this.$t('pendingSubtitle'),
            goToAccount: this.$t('goToAccount'),
            goBindBank: '',
          },
        }[this.status] || null
      )
    },
  },
  methods: {
    switchRoute(name) {
      this.$router.push({ name: name })
    },
  },
}
</script>

<style lang="stylus" scoped>
.verify-result {
  text-align: center;
  padding: 55px 24px 0;
  background-color: #fff;
}

.icon {
  width: 110px;
  height: 110px;
  margin-bottom: 8px;
}

.text {
  color: #333;
  line-height: 17px;
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  .subtitle {
    font-size: 13px;
  }
}

.btn-action /deep/ {
  width: 80vw;
  margin: 30px auto;
  .btn-go-account {
    border-radius: 20px;
    margin-bottom: 15px;
  }
  .btn-go-bank {
    width: 100%;
  }
}

</style>
